export const PlatformSettingsStep = ({ selectedPlatform }) => {
    return <div>Platform Settings for {selectedPlatform}</div>;
};
